/*eslint radix: ["error", "as-needed"]*/

import React from 'react';
import AirIcon from '../../../../../common/icons/AirIcon';

export default (text, record) => {
  const daysToMGreen = Number.isInteger(record.daysToM) && parseInt(record.daysToM) <= -10;
  const daysToMRed = Number.isInteger(record.daysToM) && parseInt(record.daysToM) >= -5;
  const daysToMOrange = Number.isInteger(record.daysToM) && !daysToMGreen && !daysToMRed;

  return (
    Number.isInteger(text) && (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
        <AirIcon type="tagliando" style={{ color: daysToMRed ? 'red' : daysToMOrange ? 'orange' : 'green' }} />
        {Number.isInteger(text) && text}
      </div>
    )
  );
};
